import { createBrowserRouter, Navigate } from "react-router-dom";
import { PrivateRoute } from "../utils//Auth/PrivateRoute";
import Login from "../pages/Login/Login";
import Home from "../pages/Home/Home";
import DefaultLayout from "../layouts/DefaultLayout";
import FluxoPerguntas from "../pages/FluxoPerguntas/FluxoPerguntas";
import DetalhesMaterial from "../pages/DetalhesMaterial/DetalhesMaterial";
import HomeTax from "../pages/HomeTax/HomeTax";
import Unauthorize from "../pages/Unauthorize/Unauthorize";
import LoginExpirado from "../pages/Login/LoginExpirado";
import Dashboard from "../pages/HomeTax/Dashboard";
import Aprovador from "../pages/HomeTax/Aprovador";
import AssociadosEng from "../pages/AssociadosEng/AssociadosEng";
import GruposResponsabilidade from "../pages/GruposResponsabilidade/GruposResponsabilidade";
import ConfigGrupos from "../pages/ConfigGrupos/ConfigGrupos";

const router = createBrowserRouter([
  {
    path: "",
    element: <DefaultLayout />,
    children: [
      { path: "/login", element: <Login /> },
      { path: "/", element: <Navigate to="/login" replace /> },
      { path: "/unauthorize", element: <Unauthorize /> },
      { path: "/sessao-expirada", element: <LoginExpirado /> },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "/home-engenheiro",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: ENGINEER"]}>
            <Home />
          </PrivateRoute>
        ),
      },
      {
        path: "/emissao-laudo",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: ENGINEER"]}>
            <FluxoPerguntas />
          </PrivateRoute>
        ),
      },
      {
        path: "/detalhes-material/:id",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: ENGINEER"]}>
            <DetalhesMaterial />
          </PrivateRoute>
        ),
      },
      {
        path: "/usuarios-associados",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: ENGINEER"]}>
            <AssociadosEng />
          </PrivateRoute>
        ),
      },
      {
        path: "/home-tax",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: TAX"]}>
            <HomeTax />
          </PrivateRoute>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: TAX"]}>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/aprovador-engenheiro",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: TAX"]}>
            <Aprovador />
          </PrivateRoute>
        ),
      },
      {
        path: "/grupos-responsabilidade",
        element: (
          <PrivateRoute allowedRoles={["KEYCLOAK_REALM_ROLE: TAX"]}>
            <GruposResponsabilidade />
          </PrivateRoute>
        ),
      },
      {
        path: "/config-grupos",
        element: (
          <PrivateRoute
            allowedRoles={[
              "KEYCLOAK_REALM_ROLE: TAX",
              "KEYCLOAK_REALM_ROLE: ENGINEER",
            ]}
          >
            <ConfigGrupos />
          </PrivateRoute>
        ),
      },
      {
        path: "/config-grupos/:groupId",
        element: (
          <PrivateRoute
            allowedRoles={[
              "KEYCLOAK_REALM_ROLE: TAX",
              "KEYCLOAK_REALM_ROLE: ENGINEER",
            ]}
          >
            <ConfigGrupos />
          </PrivateRoute>
        ),
      },
    ],
  },
]);

export default router;
